import { DepositPaymentDTO } from './DepositPaymentDTO'

export class DepositDTO {
    constructor(
        public id: string,
        public paymentMethodId: string | null,
        public amount: number,
        public currencyCode: string,
        public payments: DepositPaymentDTO[],
        public dateCreated: string
    ) { }
}
